export const convertStateToFormData = (applicationState) => {
  const formData = new FormData();

  // Step 1: Append basic step data
  formData.append('stepOne', JSON.stringify(applicationState.stepOne));
  formData.append('stepTwo', JSON.stringify(applicationState.stepTwo));
  formData.append('stepThree', JSON.stringify(applicationState.stepThree));
  formData.append('stepFour', JSON.stringify(applicationState.stepFour));

  // Step 2: Append coursePlan data (including nested objects)
  const coursePlan = applicationState.coursePlan;
  
  // Append nested objects as JSON strings
  formData.append('intendedLearners', JSON.stringify(coursePlan.intendedLearners));
  formData.append('courseFee', JSON.stringify(coursePlan.courseFee));
  
  // Append individual coursePlan fields
  formData.append('contentDeliveryStatus', coursePlan.contentDeliveryStatus);
  formData.append('courseDuration', coursePlan.courseDuration.toString());
  formData.append('courseContentHours', coursePlan.courseContentHours.toString());
  formData.append('weeklyDaySchedule', coursePlan.weeklyDaySchedule);
  
  // Handle date - convert to ISO string
  if (coursePlan.courseCommencementDate) {
    const dateValue = coursePlan.courseCommencementDate instanceof Date 
      ? coursePlan.courseCommencementDate.toISOString()
      : coursePlan.courseCommencementDate;
    formData.append('courseCommencementDate', dateValue);
  }
  
  // Optional fields - only append if they have values
  if (coursePlan.calendlyLinkOptional) {
    formData.append('calendlyLinkOptional', coursePlan.calendlyLinkOptional);
  }
  
  if (coursePlan.demoLectureURL) {
    formData.append('demoLectureURL', coursePlan.demoLectureURL);
  }
  
  // Append courseBrochure file if it exists
  if (coursePlan.courseBrochure && coursePlan.courseBrochure instanceof File) {
    formData.append('courseBrochure', coursePlan.courseBrochure);
  }

  // Step 3: Append mentor data
  const mentor = applicationState.mentor;
  
  // Append personalInformation as JSON
  formData.append('personalInformation', JSON.stringify(mentor.personalInformation));
  
  // Step 4: Handle qualifications (which has files)
  const qualifications = mentor.qualifications;
  
  // Append educationalQualification title
  formData.append('educationalQualificationTitle', qualifications.educationalQualification.title);
  
  // Append supportingDocument file if it exists
  if (qualifications.educationalQualification.supportingDocument && 
      qualifications.educationalQualification.supportingDocument instanceof File) {
    formData.append('supportingDocument', qualifications.educationalQualification.supportingDocument);
  }
  
  // Append currentProfessionalRole title
  formData.append('currentProfessionalRoleTitle', qualifications.currentProfessionalRole.title);
  
  // Append resume file (required)
  if (qualifications.currentProfessionalRole.resume && 
      qualifications.currentProfessionalRole.resume instanceof File) {
    formData.append('resume', qualifications.currentProfessionalRole.resume);
  }
  
  // Append other qualifications fields
  formData.append('workExperience', qualifications.workExperience.toString());
  formData.append('previouslyWorkedWithLMS', qualifications.previouslyWorkedWithLMS.toString());

  return formData;
};